// Universal date/time formatting for GetWork CDB.
// Spec (Phase D): DD/MM/YYYY dates, 12-hour AM/PM time.

const pad = (n) => String(n).padStart(2, "0");

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    // If already a plain YYYY-MM-DD string (no time), avoid TZ shifts
    if (typeof iso === "string" && /^\d{4}-\d{2}-\d{2}$/.test(iso)) {
      const [y, m, d] = iso.split("-");
      return `${d}/${m}/${y}`;
    }
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
  } catch {
    return String(iso);
  }
}

export function formatTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    let h = d.getHours();
    const m = pad(d.getMinutes());
    const suffix = h >= 12 ? "PM" : "AM";
    h = h % 12;
    if (h === 0) h = 12;
    return `${pad(h)}:${m} ${suffix}`;
  } catch {
    return String(iso);
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  return `${formatDate(iso)}, ${formatTime(iso)}`;
}

export function formatBytes(bytes) {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

// Turn a value that may be a legacy string or an array into a tag list.
// Split on comma/semicolon/pipe only ('/' stays as part of the value).
export function toTagList(v) {
  if (!v) return [];
  if (Array.isArray(v)) return v.filter(Boolean).map((s) => String(s).trim()).filter(Boolean);
  return String(v).split(/[,;|]+/).map((s) => s.trim()).filter(Boolean);
}
